import { Link } from "react-router-dom";

const articleList = [
  {
    slug: "cssbuy-spreadsheet-guia-completo",
    tag: "Guia",
    title: "CSSBuy Spreadsheet 2026: Guia Completo com os Melhores Links",
    excerpt: "Descubra como usar o CSSBuy Spreadsheet para encontrar os melhores produtos, vendedores verificados e links Yupoo organizados por categoria.",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20spreadsheet%20display%20on%20laptop%20screen%20with%20fashion%20products%20and%20accessories%20arranged%20around%20on%20minimalist%20warm%20desk%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20professional%20aesthetic%20modern%20workspace&width=600&height=400&seq=art-v2-card-001&orientation=landscape",
  },
  {
    slug: "planilha-cssbuy",
    tag: "Planilha",
    title: "Planilha CSSBuy: O Guia Definitivo para Compras Internacionais",
    excerpt: "Aprenda tudo sobre a planilha CSSBuy: como acessar, navegar pelas categorias e encontrar os melhores produtos com links verificados e atualizados diariamente.",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20desk%20workspace%20with%20printed%20spreadsheet%20documents%20and%20fashion%20items%20neatly%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20photography%20clean%20composition%20neutral%20beige%20background%20organized%20aesthetic&width=600&height=400&seq=art-v2-card-002&orientation=landscape",
  },
  {
    slug: "cssbuy-yupoo",
    tag: "Yupoo",
    title: "CSSBuy Yupoo: Como Encontrar os Melhores Álbuns e Vendedores",
    excerpt: "Guia completo sobre CSSBuy Yupoo: descubra como navegar pelos álbuns, identificar vendedores confiáveis e usar nossa planilha para acesso rápido aos melhores links.",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20product%20catalog%20concept%20with%20multiple%20item%20photos%20displayed%20in%20grid%20layout%20on%20warm%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20organized%20product%20showcase%20aesthetic&width=600&height=400&seq=art-v2-card-003&orientation=landscape",
  },
  {
    slug: "cssbuy-review",
    tag: "Review",
    title: "CSSBuy Review 2026: Vale a Pena? Análise Completa e Honesta",
    excerpt: "Review completo do CSSBuy em 2026: taxas, tempo de envio, qualidade do suporte, experiência do usuário e comparação com outros agentes de compra internacionais.",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20review%20concept%20with%20rating%20stars%20and%20shopping%20packages%20on%20minimalist%20warm%20desk%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20premium%20aesthetic%20product%20evaluation%20theme&width=600&height=400&seq=art-v2-card-004&orientation=landscape",
  },
  {
    slug: "como-usar-cssbuy",
    tag: "Tutorial",
    title: "Como Usar o CSSBuy: Passo a Passo Completo para Iniciantes",
    excerpt: "Tutorial completo de como usar o CSSBuy do zero: cadastro, busca de produtos, uso da planilha CSSBuy, QC photos, envio e dicas para economizar nas compras.",
    imageUrl: "https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20concept%20with%20laptop%20showing%20instructions%20and%20fashion%20items%20on%20warm%20minimalist%20desk%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20beige%20background%20educational%20aesthetic&width=600&height=400&seq=art-v2-card-005&orientation=landscape",
  },
  {
    slug: "cssbuy-vs-pandabuy",
    tag: "Comparação",
    title: "CSSBuy vs Pandabuy 2026: Qual Vale Mais a Pena para Brasileiros?",
    excerpt: "Comparação detalhada entre CSSBuy e Pandabuy: taxas, envio, suporte em português, experiência do usuário e qual oferece melhor custo-benefício para o Brasil.",
    imageUrl: "https://readdy.ai/api/search-image?query=Comparison%20concept%20two%20elegant%20shopping%20packages%20side%20by%20side%20on%20warm%20minimalist%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20versus%20theme%20balanced%20aesthetic&width=600&height=400&seq=art-v2-card-006&orientation=landscape",
  },
  {
    slug: "melhores-links",
    tag: "Links",
    title: "Melhores Links CSSBuy 2026: Coleção Completa por Categoria",
    excerpt: "Confira nossa coleção dos melhores links CSSBuy organizados por categoria: tênis, roupas, acessórios e muito mais. Todos verificados e atualizados em 2026.",
    imageUrl: "https://readdy.ai/api/search-image?query=Organized%20link%20collection%20concept%20with%20multiple%20product%20cards%20displayed%20on%20warm%20minimalist%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20curated%20catalog%20aesthetic&width=600&height=400&seq=art-v2-card-007&orientation=landscape",
  },
  {
    slug: "guia-envio",
    tag: "Envio",
    title: "Guia de Envio CSSBuy para o Brasil: Melhores Opções e Dicas",
    excerpt: "Guia completo sobre envio do CSSBuy para o Brasil: linhas disponíveis, prazos, taxas alfandegárias, triangle shipping e dicas para receber seus produtos com segurança.",
    imageUrl: "https://readdy.ai/api/search-image?query=International%20shipping%20concept%20with%20package%20boxes%20and%20globe%20on%20warm%20minimalist%20desk%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20logistics%20aesthetic%20global%20delivery%20theme&width=600&height=400&seq=art-v2-card-008&orientation=landscape",
  },
  {
    slug: "compras-seguras",
    tag: "Segurança",
    title: "Compras Seguras com CSSBuy: Dicas Essenciais para Evitar Problemas",
    excerpt: "Aprenda as melhores práticas para compras seguras com CSSBuy: verificação de vendedores, QC photos, proteção ao comprador, seguro de envio e como evitar golpes.",
    imageUrl: "https://readdy.ai/api/search-image?query=Online%20shopping%20security%20concept%20with%20shield%20symbol%20and%20lock%20icon%20next%20to%20fashion%20packages%20on%20warm%20minimalist%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20trust%20and%20safety%20aesthetic&width=600&height=400&seq=art-v2-card-009&orientation=landscape",
  },
  {
    slug: "cssbuy-spreadsheet",
    tag: "Spreadsheet",
    title: "CSSBuy Spreadsheet: A Ferramenta Essencial para Compras Internacionais",
    excerpt: "Entenda por que o CSSBuy Spreadsheet é indispensável para compradores brasileiros: organização, links verificados, economia de tempo e acesso aos melhores vendedores.",
    imageUrl: "https://readdy.ai/api/search-image?query=Essential%20digital%20tools%20concept%20with%20spreadsheet%20interface%20and%20fashion%20shopping%20elements%20on%20warm%20minimalist%20desk%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20productivity%20meets%20style%20aesthetic&width=600&height=400&seq=art-v2-card-010&orientation=landscape",
  },
];

export default function LatestArticles() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">Artigos Recentes</h2>
          <p className="mt-3 text-foreground-500 text-sm">
            Guias completos e artigos sobre CSSBuy Spreadsheet para ajudar nas suas compras
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden hover:shadow-md transition-all cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3 whitespace-nowrap">
                  {article.tag}
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-primary-600 text-sm font-medium whitespace-nowrap">
                  Ler artigo
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}